import {
  getMemberListData,
  getMemberInfoData,
  editadminlist,
  editadminSub,
  infoDelPerson,
  getOrgType,
  getStructureList,
  setStructureStatus,
  setAdmin,
  cancelAdmin,
  editTruename
} from '@/services/organization'
import {
  validName
} from '@/services/index'
import rules from './rules'
export default {
  namespaced: true,
  state: {
    submitting: false,
    // 全部的数据容器
    datas: [],
    // datas数据是否准备就绪
    datasReady: false,
    itemDatsReady: false,
    current: '1',
    isAdmin: 1,
    cId: 0,
    itemData: {},
    editDiaListData: [],
    decorators: {
      orgname: ['orgname', { rules: rules.orgname }],
      projectname: ['projectname', { rules: rules.projectname }],
      adminid: ['mobile', { rules: rules.adminlist }],
      checkcode: ['checkcode', { rules: rules.validCode }]
    },
    treeData: [],
    strutctureStatus: 0,
    bindType: 0
  },
  getters: {
    selectId (state) {
      const { itemData = 0 } = state
      return itemData.userid
    },
    treeList (state) {
      const { treeData } = state
      function deepLoop (arr, pkey) {
        arr.forEach(item => {
          item['title'] = item['sys_truename'] ? item['sys_truename'] : item['name']
          const key = item['sys_userid'] ? `sys_userid-${item['sys_userid']}` : item['id']
          item['key'] = pkey ? `${pkey}|${key}` : `${key}`
          if (item.children && item.children.length) {
            item['disabled'] = true
            deepLoop(item.children, item['key'])
          }
        })
      }
      deepLoop(treeData, null)
      return treeData
    },
    treeDefault (state, getters) {
      const { treeList } = getters
      let defalutVal = {}
      function deepLoop (arr) {
        // return arr.find(item => {
        //   debugger
        //   if (item.sys_userid) {
        //     return item
        //   } else {
        //     if (item.children && item.children.length) {
        //       deepLoop(item.children)
        //     }
        //   }
        // })
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].sys_userid) {
            defalutVal = arr[i]
            return false
          } else {
            if (arr[i].children && arr[i].children.length && (Object.keys(defalutVal).length === 0)) {
              deepLoop(arr[i].children)
            }
          }
        }
      }
      deepLoop(treeList)
      return defalutVal
    }
  },
  mutations: {
    setSubmitting (state, type) {
      state.submitting = type
    },
    // 设置数据容器的值
    setDatas (state, datas) {
      state.datas = datas
      state.datasReady = true
    },
    // setCurrentIndex (state, id) {
    //   state.current = id
    // },
    // setIsAdmin (state, id) {
    //   state.isAdmin = id
    // },
    setCId (state, cid) {
      state.cId = cid
    },
    // 设置当前数据
    setItemData (state, datas) {
      state.itemData = datas
      if (Object.keys(datas).length) {
        state.itemDatsReady = true
      } else {
        state.itemDatsReady = false
      }
    },
    setEditDiaListData (state, datas) {
      state.editDiaListData = datas
    },
    setStrutctureStatus (state, status) {
      state.strutctureStatus = status
    },
    setBindType (state, type) {
      state.bindType = type
    },
    setTreeData (state, datas) {
      state.treeData = datas
    }
  },
  actions: {
    // 人员管理获取管理员或者成员列表
    async fetchCurrentDatas ({ commit, state, dispatch }, data) {
      commit('setSubmitting', true)
      const chain = await getMemberListData()
        .onSuccess(async (raw) => {
          if (raw.list.length) {
            commit('setDatas', raw.list)
            const data2 = Object.assign(data, { userid: state.datas[0].userid })
            const res = await dispatch('fetchItemInfoDatas', data2)
            res.fetch()
          } else {
            commit('setDatas', [])
            commit('setItemData', {})
          }
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    // 人员管理获取管理员或者成员详情
    async fetchItemInfoDatas ({ commit, state }, data) {
      // commit('setSubmitting', true)
      const chain = await getMemberInfoData()
        .params(data)
        .onSuccess((raw) => {
          commit('setItemData', raw)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },

    //  获取编辑管理员列表数据
    async fetchEditDiaListDatas ({ commit, state }) {
      // commit('setSubmitting', true)
      const chain = await editadminlist()
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },

    // 编辑管理人员并提交
    async ajaxSaveAdminList ({ commit, state, dispatch }, data) {
      commit('setSubmitting', true)
      const chain = await editadminSub()
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },

    //  删除人员
    async ajaxDelUser ({ commit, state }) {
      commit('setSubmitting', true)
      const chain = await infoDelPerson()
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },

    //  获取组织状态
    async getOrgType ({ commit, state }) {
      const chain = await getOrgType()
        .onSuccess(raw => {
          commit('setStrutctureStatus', raw.dingtalk_structure_status)
          commit('setBindType', raw.bind_type)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    //  获取组织状态
    async setStructureStatus2 ({ commit, state }, data) {
      const chain = await setStructureStatus()
        .params(data)
        .onSuccess(raw => {
          commit('setStrutctureStatus', raw.dingtalk_structure_status)
          // commit('setBindType', raw.bind_type)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async getStructureList ({ commit, dispatch, state, getters }, data) {
      const chain = await getStructureList()
        .params(data)
        .onSuccess(async (raw) => {
          commit('setTreeData', raw)
          const res = await dispatch('fetchItemInfoDatas', Object.assign(data, { userid: getters.treeDefault.sys_userid }))
          res.fetch()
          // commit('setBindType', raw.bind_type)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async setAdmin ({ commit, state }, data) {
      const chain = !state.itemData.isadmin ? (await setAdmin()) : await cancelAdmin()
      chain.params(data)
        .onSuccess(raw => {
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async ajaxEditTruename ({ commit, dispatch }) {
      const chain = await editTruename()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async validName ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await validName()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    }
  }
}
